const SET_STATE = "SET_STATE";

// Define reducer function
const sidebarReducer = (state = { isExpended: false }, action) => {
  switch (action.type) {
    case SET_STATE:
      return {
        ...state,
        isExpended: action.payload,
      };
    // case COLLAPSE:
    //   return {
    //     ...state,
    //     isExpended: false,
    //   };
    default:
      return state;
  }
};

const setSidebarState = (isExpended) => ({
  type: SET_STATE,
  payload: isExpended,
});

// const collapseSidebar = () => ({
//   type: COLLAPSE,
// });

export { setSidebarState };
export default sidebarReducer;
